import { AaOtpSendcodeReq, AaOtpSendcodeResp } from 'app/bff/models/aa/aaOtpSendcode';
import { AaOtpVerifyReq } from 'app/bff/models/aa/aaOtpVerify';
import { MbUpdateinfoReq } from 'app/bff/models/mb/mbUpdateinfo';
import { ProcessStepCodesEnum } from 'app/features/Member/Register/Permission/types';
import { FormValues as ClausesFormValues } from 'app/features/Member/Register/Permission/Clauses/types';
import { FormValues as ConfirmInfoFormValues } from 'app/features/Member/Register/Permission/ConfirmInfo/types';

// State type
export interface PermissionState {
  process: ProcessState;
}

interface ProcessState {
  accessibleSteps: ProcessStepCodesEnum[];
  clauses: {
    data?: ClausesFormValues;
  };
  confirmInfo: {
    data?: ConfirmInfoFormValues;
    otpAuth: {
      otp?: AaOtpSendcodeResp;
    }
  }
}
// ::: End

// Actions type constant
export const MEMBER_REGISTER_PERMISSION__SET_ACCESSIBLE_STEP = 'MEMBER_REGISTER_PERMISSION__SET_ACCESSIBLE_STEP';
export const MEMBER_REGISTER_PERMISSION__SAVE_CLAUSES_PAGE_DATA = 'MEMBER_REGISTER_PERMISSION__SAVE_CLAUSES_PAGE_DATA';
export const MEMBER_REGISTER_PERMISSION__SAVE_CONFIRM_INFO_PAGE_DATA = 'MEMBER_REGISTER_PERMISSION__SAVE_CONFIRM_INFO_PAGE_DATA';
export const MEMBER_REGISTER_PERMISSION__SEND_OTP = 'MEMBER_REGISTER_PERMISSION__SEND_OTP';
export const MEMBER_REGISTER_PERMISSION__SEND_OTP_DONE = 'MEMBER_REGISTER_PERMISSION__SEND_OTP_DONE';
export const MEMBER_REGISTER_PERMISSION__RESEND_OTP = 'MEMBER_REGISTER_PERMISSION__RESEND_OTP';
export const MEMBER_REGISTER_PERMISSION__RESEND_OTP_DONE = 'MEMBER_REGISTER_PERMISSION__RESEND_OTP_DONE';
export const MEMBER_REGISTER_PERMISSION__AUTH_OTP = 'MEMBER_REGISTER_PERMISSION__AUTH_OTP';
export const MEMBER_REGISTER_PERMISSION__SEND_REGISTER_DATA = 'MEMBER_REGISTER_PERMISSION__SEND_REGISTER_DATA';
export const MEMBER_REGISTER_PERMISSION__UPDATE_CACHE = 'MEMBER_REGISTER_PERMISSION__UPDATE_CACHE';
export const MEMBER_REGISTER_PERMISSION__RESET_CACHE = 'MEMBER_REGISTER_PERMISSION__RESET_CACHE';
// ::: End

// Action creators type
export interface SetAccessibleStepAction {
  type: typeof MEMBER_REGISTER_PERMISSION__SET_ACCESSIBLE_STEP;
  payload: {
    step: ProcessStepCodesEnum;
  };
}

export interface SaveClausesPageDataAction {
  type: typeof MEMBER_REGISTER_PERMISSION__SAVE_CLAUSES_PAGE_DATA;
  payload: {
    data: ClausesFormValues;
  };
}

export interface SaveConfirmInfoPageDataAction {
  type: typeof MEMBER_REGISTER_PERMISSION__SAVE_CONFIRM_INFO_PAGE_DATA;
  payload: {
    data: ConfirmInfoFormValues;
  };
}

export interface SendOTPAction {
  type: typeof MEMBER_REGISTER_PERMISSION__SEND_OTP;
  payload: {
    args: AaOtpSendcodeReq;
  };
}

export interface SendOTPDoneAction {
  type: typeof MEMBER_REGISTER_PERMISSION__SEND_OTP_DONE;
  payload: {
    response: AaOtpSendcodeResp;
  };
}

export interface ResendOTPAction {
  type: typeof MEMBER_REGISTER_PERMISSION__RESEND_OTP;
  payload: {
    args: AaOtpSendcodeReq;
  };
}

export interface ResendOTPDoneAction {
  type: typeof MEMBER_REGISTER_PERMISSION__RESEND_OTP_DONE;
  payload: {
    response: AaOtpSendcodeResp;
  };
}

export interface AuthOTPAction {
  type: typeof MEMBER_REGISTER_PERMISSION__AUTH_OTP;
  payload: {
    authOTPArgs: AaOtpVerifyReq;
    registerArgs: MbUpdateinfoReq;
  };
}

export interface SendRegisterDataAction {
  type: typeof MEMBER_REGISTER_PERMISSION__SEND_REGISTER_DATA;
  payload: {
    args: MbUpdateinfoReq;
  };
}

export interface UpdateCacheAction {
  type: typeof MEMBER_REGISTER_PERMISSION__UPDATE_CACHE;
  payload: {
    cache: PermissionState;
  };
}

export interface ResetCacheAction {
  type: typeof MEMBER_REGISTER_PERMISSION__RESET_CACHE;
}

export type PermissionActions =
    SetAccessibleStepAction
  | SaveClausesPageDataAction
  | SaveConfirmInfoPageDataAction
  | SendOTPAction
  | SendOTPDoneAction
  | ResendOTPAction
  | ResendOTPDoneAction
  | AuthOTPAction
  | SendRegisterDataAction
  | UpdateCacheAction
  | ResetCacheAction;
// ::: End
